import { render, staticRenderFns } from "./landing.html?vue&type=template&id=1131fbd6&scoped=true&external"
import script from "./landing.js?vue&type=script&lang=js&external"
export * from "./landing.js?vue&type=script&lang=js&external"
import style0 from "./landing.scss?vue&type=style&index=0&id=1131fbd6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1131fbd6",
  null
  
)

export default component.exports